import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../../components/common/Section';

// 定义缺失的样式组件
const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 1.5rem;
  box-shadow: ${props => props.theme.shadows.small};
  transition: transform ${props => props.theme.transitions.fast};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: ${props => props.theme.shadows.medium};
  }
`;

const FeatureTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const FeatureDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
`;

const MDM = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      title: t('products.mdm.features.governance'),
      description: '建立数据治理框架，定义数据所有权、策略和标准。'
    },
    {
      title: t('products.mdm.features.quality'),
      description: '通过数据清洗、标准化和验证，提高数据质量。'
    },
    {
      title: t('products.mdm.features.integration'),
      description: '与企业各系统集成，确保数据在整个组织中的一致性。'
    },
    {
      title: t('products.mdm.features.hierarchy'),
      description: '管理复杂的数据层次结构和关系，支持业务分析和报告。'
    },
    {
      title: t('products.mdm.features.stewardship'),
      description: '提供工具和流程，支持数据管理员维护主数据。'
    }
  ];
  
  return (
    <>
      <Section 
        title={t('products.mdm.title')} 
        subtitle={t('products.mdm.subtitle')}
      >
        <p>{t('products.mdm.content')}</p>
        
        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </Section>
    </>
  );
};

export default MDM;